<template>
    <div>
        <div class="top-right-fixed-button">
            <img @click="refreshReceipt()" src="/img/refresh.webp" width="47px">
        </div>
        <AppPushNotification ref="notification" :title="notificationModel.title" :text="notificationModel.text"
            :color="notificationModel.color" />
        <div v-if="typeOfOrder == 4" class="mb-3">
            <div v-show="loading" class="lds-ripple" style="height: 50vh;">
                <div></div>
                <div></div>
            </div>
            <LocationPicker v-if="!loading" height="55vh" :start="shopLocation" :end="customerLocation"
                ref="location_app"></LocationPicker>
        </div>
        <OrderStatusCard :receipt="receipt" class="pr-2 pl-2 mt-1" />

        <!-- <div v-if="hasTable()" @click="openModal()" class="p-2">
            <div class="tracking-graybox-container text-center p-3 h5 mb-0">
                <i class="fi fi-rr-plus mr-1"></i> {{ $t('SelectTableToAdd') }}
            </div>
        </div> -->

        <div style="background-color: #ffffff;">
            <div class="order-deatils-box pt-0 row">
                <div class="col-12 h5 m-0 mt-3 ">
                    {{ itemCount }} {{ $t('item') }}
                </div>
                <div class="col-12 ">
                    <div class="text-grey mt-3">
                        <div v-for="(product, index) in receipt.receiptItems" :key="index">
                            <div class="order-item">
                                <img v-if="product.remoteImagePath" :src="product.remoteImagePath">
                                <img v-else :style="{ 'background-color': getImgColor(product.indexColor) }"
                                    class="product-image-color-sm">
                                <div class="order-details">
                                    <span class="limited-text h5 mb-0">{{ getCartPLUName(product) }}</span>
                                    <small v-for="(option, index) in product.orderedOptions" :key="option.optionItemName + index"
                                        class="limited-text-one text-description">• {{ getOptionItemTranslation(option) }}</small>
                                    <small v-if="product.note" class="text-description">{{ $t('note') }} : {{
                                        product.note }}</small>
                                    <div class="order-quantity h5">x {{ product.quantity }}</div>
                                </div>
                                <div class="order-quantity-price h5">
                                    <div>
                                        <span :class="getOrderStatusColor(product.status)">
                                            {{ getOrderStatus(product.status) || '' }}
                                        </span>
                                    </div>
                                    <div class="order-price h5">฿{{ summary(product.netAmount) }}</div>
                                </div>
                            </div>
                            <hr class="mt-2" style="border: 1px solid #f1f1f1;">
                        </div>
                        <table class="tracking-table">
                            <tbody class="h5">
                                <tr>
                                    <td class="text-grey">{{ $t('docTotal') }} ({{ itemCount }} {{
                                        $t('item') }})</td>
                                    <td class="text-right">{{ convertCurrency(receipt.netAmount) }} THB</td>
                                </tr>
                                <tr v-if="!receipt.isVATIncluded">
                                    <td class="text-grey">{{ $t('vat') }} ({{ receipt.vatBase }}%)</td>
                                    <td class="text-right">{{ convertCurrency(receipt.vatAmount) }} THB</td>
                                </tr>
                                <tr v-if="receipt.discountAmount > 0">
                                    <td class="text-grey">{{ $t('discount') }}</td>
                                    <td class="text-right">{{ convertCurrency(receipt.discountAmount) }} THB</td>
                                </tr>
                                <tr style="border: none;" class="h4">
                                    <td class="text-dark">{{ $t('totalAmount') }}</td>
                                    <td class="text-right" :style="{ color: 'var(--bg-color-theme)' }">{{
                                        convertCurrency(receipt.grandTotal) }} THB</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="order-deatils-box mt-2">
                <div style="width: 100%;">
                    <div class="d-flex row">
                        <i class="fi fi-rr-document h4 col-1"></i>
                        <span class="h5 col-11"> {{ $t('orderDetails') }}</span>
                    </div>
                    <table class="tracking-table">
                        <tbody>
                            <tr>
                                <td class="text-grey ">{{ $t('orderId') }} </td>
                                <td class="text-right text-grey">#{{ receipt.receiptNumber || receipt.orderNo }}</td>
                            </tr>
                            <tr>
                                <td class="text-grey">{{ $t('orderTime') }}</td>
                                <td class="text-right text-grey">{{ showCreatedAtTime(receipt.payReceiptAt ||
                                    receipt.created_at) }}
                                </td>
                            </tr>
                            <tr v-if="receipt.remark">
                                <td class="text-grey">{{ $t('note') }}</td>
                                <td style="width: 50%;" class="text-right text-grey">{{ receipt.remark }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <CButton @click="callShop()"
                        style="border-radius: 30px; border-color: var(--bg-color-theme); color: var(--bg-color-theme); "
                        variant="outline" block class="p-2 mt-3">
                        {{ $t('contactShop') }}
                    </CButton>
                </div>

            </div>
            <div class="modal fade" tabindex="-1" id="table-modal" style="z-index: 2010;">
                <div class="modal-dialog">
                    <div class="modal-content" style="background-color: unset;">
                        <div class="modal-body text-center p-0" style="background-color: white; overflow: scroll;">
                            <div class="text-right p-2">
                                <img @click="closeModal()" src="/img/close.png" width="40px">
                            </div>
                            <template v-if="!loadingModal">
                                <h4>{{ $t('SelectTableToAdd') }}</h4>
                                <span class="text-grey" v-html="$t('SelectTableToAddDesp')"></span>
                                <div class="table-container">
                                    <div v-for="zone in tables" class="row">
                                        <h4 class="col-12 text-left mt-3" v-if="zone.zoneName">• {{ zone.zoneName }}
                                        </h4>
                                        <div v-for="table in zone.tables" class="col-6 col-md-3 p-1">
                                            <div 
                                                :class="['table-btn', { 'selected': selectedTable.objectId === table.objectId }]">
                                                <h6>{{ table.name }}</h6>
                                                <span v-if="!table.currentReceipt && !table.receiptCompleted"
                                                    class="badge-pill badge-served">{{
                                                        $t('availableTable') }}</span>
                                                <span v-else class="badge-pill badge-danger">{{ $t('unAvailableTable')
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="showBottomBtn" class="bottom-btn">
                                    <CButton :disabled="loadingApply" @click="updateReceiptToTable()"
                                        class="btn-color-theme" block>
                                        <CSpinner v-if="loadingApply" class="mb-2" size="sm" /> {{ $t('selectd') }} {{
                                            selectedTable.name }}
                                    </CButton>
                                </div>
                            </template>
                            <template v-else>
                                <div class="lds-ripple">
                                    <div></div>
                                    <div></div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import util from '@/util/util'
import '@/util/delivery.css'
import '@/util/menu.css'
import '@/util/loader.css'
import LocationPicker from '@/components/LocationPicker'
import StepProgressBar from '@/components/AppStepProgressBar'
import OrderStatusCard from '@/components/AppOrderHubStatus'
import AppPushNotification from '@/components/AppPushNotification.vue'
import pos from '@/services/pos'
import moment from 'moment'

export default {
    components: {
        LocationPicker,
        StepProgressBar,
        OrderStatusCard,
        AppPushNotification
    },
    data() {
        return {
            loading: true,
            infoHeight: '40vh',
            currentStep: 1,
            receipt: {
                items: [],
                total: '',
                id: '',
                timeStamp: '',
                note: '',
                delivery: { distance: 0, deliveryAddress: {}, latlng: {} },
            },
            shopLocation: { lat: 13.742364747821984, lng: 100.58573247530744 },
            customerLocation: { lat: 13.8027837, lng: 100.5552302 },
            driverType: '',
            toggleStates: ['Lalamove', ''],
            typeOfOrder: 0,
            address: [],
            paymentMethods: [
                { id: "qr", name: "QRCode", icon: "qrIcon.webp", iconHeader: "thaiqr_banner.webp", bgColor: "#113566", type: 'T' },
                { id: "qrBBL", name: "QRCodeBBL", icon: "masterCardIcon.webp", iconHeader: "credit_.webp", bgColor: "#f5f5f5", type: '5' },
                { id: "alipay", name: "Alipay", icon: "aliPayIcon.webp", iconHeader: "aliPay_.webp", bgColor: "#1677ff", type: 'X' },
                { id: "rabbitpay", name: "Rabbit LINE Pay", icon: "rabbitPayIcon.webp", iconHeader: "rabbit_.webp", bgColor: "#09bf5b", type: 'L' },
                { id: "truewallet", name: "TrueMoney Wallet", icon: "trueWalletIcon.webp", iconHeader: "trueWallet_.webp", bgColor: "#f5f5f5", type: '4' },
            ],
            tables: [],
            selectedTable: {
                objectId: ''
            },
            showBottomBtn: false,
            notificationModel: {
                color: '',
                title: '',
                text: '',
            },
            loadingModal: false,
            loadingApply: false,
            canRefresh: true
        }
    },
    computed: {
        ...mapGetters(['shopLineOA']),
        driverDetails() {
            return { phoneNumber: '0988888888', name: 'อัครเดช วิทยาวุฒิรัตน์', type: this.driverType }
        },
        trackingStyle() {
            if (this.typeOfOrder == 4) {
                return { width: '100%', height: this.infoHeight, overflowX: 'clip', transition: 'height 0.5s ease' }
            } else {
                return { width: '100%' }
            }
        },
        shopObjectId() {
            return `${localStorage.getItem('shopObjectId')}`
        },
        uid() {
            return `${localStorage.getItem('uid')}`
        },
        shop() {
            return this.shopLineOA.find(detail => detail.objectId === this.shopObjectId)
        },
        shopName() {
            return this.shop?.shopName || ''
        },
        logo() {
            return this.shop?.remoteImagePath || 'https://cdn-icons-png.flaticon.com/512/4711/4711299.png'
        },
        objectId() {
            return this.$route.query.objectId
        },
        clipArt() {
            switch (this.currentStep) {
                case 1:
                    return '/img/recivedOrder.png'
                case 2:
                    return '/img/prepare.png'
                case 3:
                    return this.typeOfOrder === 3 ? '/img/foodReady.png' : '/img/deliveryNow.png'
                default:
                    return '/img/thanks.png'
            }
        },
        paymentMethod() {
            const method = this.paymentMethods.find(m => m.type === this.receipt?.paymentMethod);
            return method ? method.name : 'UNKNOWN METHOD';
        },
        typeOfOrderDetails() {
            const typeOfOrder = this.receipt.typeOfOrder || 1
            switch (typeOfOrder) {
                case 1:
                    return {
                        icon: 'fi fi-rs-marker h4',
                        header: 'typeOfOrder',
                        detail: 'dine-in',
                    }
                case 3:
                    return {
                        icon: 'fi fi-rs-marker h4',
                        header: 'deliveryAddress',
                        detail: 'pickupAtShop',
                    }
                default:
                    return {}
                    break;
            }
        },
        tableName() {
            return this.receipt.tableLayout.name || this.receipt.table.name || ''
        },
        itemCount() {
            const receiptItems = this.receipt.receiptItems || null
            if (receiptItems) {
                return receiptItems.filter(
                    item => item.deleted_at === undefined 
                ).length;
            }
            return 0;
        }
    },
    created() {
        this.getReceipt()
    },
    mounted() {
        window.addEventListener('message', this.handlePaymentMessage)
    },
    beforeDestroy() {
        window.removeEventListener('message', this.handlePaymentMessage)
    },
    methods: {
        ...util,
        getCartPLUName(list) {
            const locale = this.$i18n.locale
            const translation = list.nameTranslation || list.productPLU?.nameTranslation
            if (translation && translation[locale]) {
                return translation[locale]
            }
            return list.productPLU?.name || list.pluName || ''
        },
    getOptionItemTranslation(option) {
        const locale = this.$i18n.locale
        const translation = option.nameTranslation || option.optionItem?.nameTranslation
        if (translation && translation[locale]) {
            return translation[locale]
        }
        return option.optionItemName || ''
    },

        handlePaymentMessage(event) {
            if (!event.data) return

            // console.log('ได้เงินแล้ว:', event.data)

            if (event.data.type === 'PAYMENT_SUCCESS') {

                const objectId = event.data.objectId

                // ✅ ปิด modal (ถ้ามี)
                $('#payment-pending-modal').modal('hide')

                // ✅ ไปหน้า tracking
                this.$router.push(`/delivery/tracking?objectId=${objectId}&redirect=payment`)
            }
        },
        getImgColor(indexColor) {
            return util.generateColor(indexColor)
        },
        summary(amount) {
            return util.convertCurrency(amount)
        },
        callDriver() {
            window.location.href = `tel:${this.shop.tel}`
        },
        setDriver() {
            const currentIndex = this.toggleStates.indexOf(this.driverType);
            const nextIndex = (currentIndex + 1) % this.toggleStates.length;
            this.driverType = this.toggleStates[nextIndex];
        },
        getTypeOfOrderClass() {
            if (this.typeOfOrder == 4) {
                return 'tracking-info fixed-bottom p-3'
            } else {
                return ''
            }
        },
        showCreatedAtTime(time) {
            if (time) {
                return moment(time).format('DD/MM/YYYY, HH:mm');
            } else {
                return ''
            }
        },
        async getReceipt() {
            const uid = localStorage.getItem('uid')
            let token = this.$route.query.token || localStorage.getItem('token')
        //    console.log(token);
           
            const res = await pos({
                url: `/api/v1.3/${uid}/profile/order?objectId=${this.objectId}`,
                method: 'get',
                headers: {
                    Authorization: token
                }
            })
            // console.log('res tracking',res);
            
            if (res.data.error.code == 0) {
                let order = {}
                order = res?.data?.data || {}

                this.receipt = order || {}
                this.address = this.receipt?.address || []
                this.customerLocation = { lat: 13.7295154, lng: 100.5453136 }
                this.typeOfOrder = this.receipt.typeOfOrder
                this.loading = false

                this.$nextTick(() => {
                    setTimeout(() => {
                        if (this.$refs.location_app) {
                            this.$refs.location_app.adjustMapBounds();
                        }
                    }, 1000);
                });
                this.loading = false
            }
            else if (res.data.error.code == 402) {
                this.renewToken()
            } else if (res.data.error.code == 4000) {
                this.logOut()
            }
        },
        setInfoBoxHeight() {
            this.infoHeight = this.infoHeight === '40vh' ? '80vh' : '40vh'
        },
        getStatusHeader() {
            //Delivery
            if (this.typeOfOrder == 4) {
                const statusHeaders = [
                    this.$i18n.t('shopReceivedOrder'),
                    this.$i18n.t('prepareingOrder'),
                    this.$i18n.t('deliveringOrder'),
                    this.$i18n.t('deliveredOrder')
                ]
                return statusHeaders[this.currentStep - 1]
            } else {
                //Pick-Up
                const statusHeaders = [
                    this.$i18n.t('shopReceivedOrder'),
                    this.$i18n.t('prepareingOrder'),
                    this.$i18n.t('pickupOrderReady'),
                    this.$i18n.t('pickedupOrder')
                ]
                return statusHeaders[this.currentStep - 1]
            }
        },
        getStatusDescription() {
            const statusHeaders = [
                this.$i18n.t('noticeIfOrderReady'),
                this.$i18n.t('noticeIfOrderReady'),
                this.$i18n.t('orderIsReady'),
                this.$i18n.t('thanksForOrdering')
            ]
            return statusHeaders[this.currentStep - 1]

        },
        convertCurrency(total) {
            if (typeof total !== 'number' || isNaN(total)) {
                return '-'; // or handle as needed
            }
            return util.convertCurrency(total);
        },
        getOrderStatusColor(status) {
            switch (status) {
                case 'N':
                case 'ออเดอร์ใหม่':
                    return 'badge badge-info'
                case 'P':
                case 'กำลังทำ':
                    return 'badge badge-warning'
                case 'C':
                case 'ยกเลิก':
                    return 'badge badge-danger'
                case 'S':
                case 'เสิร์ฟแล้ว':
                    return 'badge badge-served'
                case 'R':
                case 'รอเสิร์ฟ':
                    return 'badge badge-wait-serve '
                case 'A':
                case 'เรียบร้อย':
                    return 'badge badge-success'
                default:
                    return ''
            }
        },
        getOrderStatus(status) {
            switch (status) {
                case 'N':
                case 'ออเดอร์ใหม่':
                    return this.$i18n.t('newOrder')
                case 'P':
                case 'กำลังทำ':
                    return this.$i18n.t('OnPreparing')
                case 'C':
                case 'ยกเลิก':
                    return this.$i18n.t('cancel')
                case 'S':
                case 'เสิร์ฟแล้ว':
                    return this.$i18n.t('served')
                case 'R':
                case 'รอเสิร์ฟ':
                    return this.$i18n.t('waitForServe')
                case 'A':
                case 'เรียบร้อย':
                    return this.$i18n.t('OnSuccess')
                default:
                    return ''
            }
        },
        geTypeOfOrderText(type) {
            switch (type) {
                case 1:
                    return 'dine-in'
                case 3:
                    return 'pickupType'

                default:
                    return type;
            }
        },
        getTypeOfOrderIcon(type) {
            switch (type) {
                case 1:
                    return 'fi fi-rr-utensils'
                case 3:
                    return 'fi fi-rr-shopping-bag'

                default:
                    return type;
            }
        },
        callShop() {
            window.location.href = `tel:${this.shop.tel}`
        },
        openModal() {
            this.getTables()
            $('#table-modal').modal('show');
        },
        closeModal() {
            $('#table-modal').modal('hide');
        },
        selectTable(table) {
            if (!table.currentReceipt && !table.receiptCompleted) {
                this.selectedTable = table
                this.showBottomBtn = true
            }
        },
        async getTables() {
            this.loadingModal = true
            const uid = localStorage.getItem('uid')
            const shopObjectId = localStorage.getItem('shopObjectId')
            const res = await pos({
                url: `/api/v1.3/${uid}/profile/table?shopObjectId=${shopObjectId}`,
                method: 'get',
            })
            this.tables = this.organizeTableLayout(res.data?.data)

            this.loadingModal = false

        },
        organizeTableLayout(tables) {
            let tableLayout = [];
            if (tables) {
                let groupedTables = tables.reduce((acc, table) => {
                    if (!acc[table.zoneObjectId]) {
                        acc[table.zoneObjectId] = {
                            zoneName: table.zoneName || null,
                            zoneObjectId: table.zoneObjectId || null,
                            tables: []
                        };
                    }
                    acc[table.zoneObjectId].tables.push(table);
                    return acc;
                }, {});
                tableLayout = Object.values(groupedTables);
            }
            return tableLayout;
        },
        showNotification(title, text, color) {
            this.notificationModel = {
                color: color,
                title: title,
                text: text,
            }
            this.$refs.notification.pushNotification();
        },
        async updateReceiptToTable() {
            this.loadingApply = true
            const uid = localStorage.getItem('uid')
            const shopObjectId = localStorage.getItem('shopObjectId')

            const data = {
                shopObjectId: shopObjectId,
                tableObjectId: this.selectedTable.objectId,
                receiptObjectId: this.objectId
            }

            const res = await pos({
                url: `/api/v1.3/${uid}/profile/table?shopObjectId=${shopObjectId}`,
                method: 'patch',
                data: data
            })
            if (res.data?.error?.code == 0) {
                this.showNotification('เลือกโต๊ะสำเร็จ', '', 'success')
                this.getReceipt()
                $('#table-modal').modal('hide');
            } else {
                this.showNotification(res.data?.error?.message, '', 'warning')
            }
            this.loadingApply = false

        },
        hasTable() {
            if (!this.receipt.tableLayout
                && !this.receipt.table
                && this.receipt.typeOfOrder == 1
                && this.receipt.order.orderStatus !== 'FINISH'
                && this.receipt.order.orderStatus !== 'REJECT'
                && this.receipt.order.orderStatus !== 'CANCEL') {
                return true
            } else {
                return false
            }
        },
        async refreshReceipt() {
            if (this.canRefresh) {
                await this.getReceipt()
                this.showNotification(this.$t('updatedStaus'), '', 'success')
                this.canRefresh = false
                setTimeout(() => {
                    this.canRefresh = true
                }, 5000);
            } else {
                this.showNotification(this.$t('updatedStaus'), '', 'success')
            }
        }

    },
}
</script>
